"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interpret = exports.interpretChildren = exports.interpretNode = void 0;
const libraryConfig = require("../package.json");
const allowList_1 = require("./interpreter/allowList");
const denyList_1 = require("./interpreter/denyList");
const matchStatus_1 = require("./interpreter/matchStatus");
const multivariateNode_1 = require("./interpreter/multivariateNode");
const percentageNode_1 = require("./interpreter/percentageNode");
const types_1 = require("./types");
function isRuleNode(node) {
    return Boolean(node.children);
}
function interpretNodeByType(ruleNode, context) {
    // Store string type value for error messaging
    const nodeTypeString = ruleNode.nodeType;
    switch (ruleNode.nodeType) {
        case types_1.NodeType.Allowlist:
        case types_1.NodeType.Whitelist:
            return allowList_1.interpretAllowListNode(ruleNode, context, interpretChildren);
        case types_1.NodeType.Blacklist:
        case types_1.NodeType.Denylist:
            return denyList_1.interpretDenyListNode(ruleNode, context, interpretChildren);
        case types_1.NodeType.Percentage:
            return percentageNode_1.interpretPercentageNode(ruleNode, context, interpretChildren);
        case types_1.NodeType.Multivariate:
            return multivariateNode_1.interpretMultivariateNode(ruleNode, context, interpretNode);
        default:
            context.sendError(`Found unsupported nodeType for dynamic value
         ${context.getDynamicValueName()}: ${nodeTypeString}`);
            context.addResolutionLog(`Found unsupported nodeType for dynamic value
         ${context.getDynamicValueName()}: ${nodeTypeString}`);
            return matchStatus_1.error();
    }
}
/**
 * Function that interprets a single node to determine resolved values
 * @param node
 * @param context
 */
function interpretNode(node, context) {
    if (node.nodeType === types_1.NodeType.Value) {
        if (Boolean(node.tag)) {
            context.addResolutionDetails({
                tag: node.tag,
            });
        }
        context.addResolutionLog(`SUCCESS: Found value node in children. Returning: ${node.value}`);
        return matchStatus_1.success(node.value);
    }
    return interpretNodeByType(node, context);
}
exports.interpretNode = interpretNode;
function interpretChildren(node, context) {
    if (node.nodeType === types_1.NodeType.Value) {
        context.addResolutionLog(`SUCCESS: Found value node in children. Returning: ${node.value}`);
        return matchStatus_1.success(node.value);
    }
    if (!isRuleNode(node)) {
        context.addResolutionLog(`ERROR: Found non-value non-rule node.`);
        return matchStatus_1.error();
    }
    for (const childNode of node.children) {
        context.addResolutionLog(`Interpreting children: rule ${node.children.indexOf(childNode) + 1} of ${node.children.length}`);
        const result = interpretNode(childNode, context);
        if (matchStatus_1.isError(result)) {
            return result;
        }
        if (!matchStatus_1.isFailure(result)) {
            return result;
        }
    }
    return matchStatus_1.error();
}
exports.interpretChildren = interpretChildren;
/**
 * Interpreter function that resolves the dynamic value of given context
 * @param node
 * @param context
 */
function interpret(node, context, typeValidator) {
    context.addResolutionLog(`JS DVL Version: ${libraryConfig.version}`);
    if (node.children.length === 0) {
        context.addResolutionLog(`NO CHILDREN: checking default type: ${node.default.value}`);
        if (typeValidator(node.default.value)) {
            context.addResolutionLog(`SUCESS: Returning default: ${node.default.value}`);
            return {
                value: node.default.value,
                trackingData: context.getResolutionDetails(),
            };
        }
        context.addResolutionLog(`ERROR: mismatched default type. Returning: null`);
        return {
            value: null,
            trackingData: context.getResolutionDetails(),
        };
    }
    for (const childNode of node.children) {
        context.addResolutionLog(`Interpreting children: rule ${node.children.indexOf(childNode) + 1} of ${node.children.length}`);
        const result = interpretNode(childNode, context);
        if (matchStatus_1.isError(result)) {
            context.addResolutionLog(`ERROR: returning: null`);
            return {
                value: null,
                trackingData: context.getResolutionDetails(),
            };
        }
        if (!matchStatus_1.isFailure(result)) {
            context.addResolutionLog(`SUCCESS: checking return type: ${result.value}`);
            if (typeValidator(result.value)) {
                context.addResolutionLog(`SUCCESS: returning: ${result.value}`);
                return {
                    value: result.value,
                    trackingData: context.getResolutionDetails(),
                };
            }
            context.addResolutionLog(`ERROR: mismatched value type. Returning: null`);
            return {
                value: null,
                trackingData: context.getResolutionDetails(),
            };
        }
    }
    context.addResolutionLog(`FALL THROUGH: checking default type: ${node.default.value}`);
    if (typeValidator(node.default.value)) {
        context.addResolutionLog(`FALL THROUGH SUCCESS: returning default: ${node.default.value}`);
        return {
            value: node.default.value,
            trackingData: context.getResolutionDetails(),
        };
    }
    context.addResolutionLog(`FALL THROUGH ERROR: mismatched default type. Returning: null`);
    return {
        value: null,
        trackingData: context.getResolutionDetails(),
    };
}
exports.interpret = interpret;
//# sourceMappingURL=interpreter.js.map